<template>
    <div class="user-list-box">
        <el-row class="user-list-item">
            <el-col>
            <!-- head空格部分 -->
                <el-row style="height:58px;background: #F9FAFB;box-shadow: 0px 0px 13px 3px rgba(141, 141, 141, 0.11);">
                </el-row>

            <!-- companyChat:1表示企业和企业 null 企业和个人-->
            <template  v-for="(item,index) in informationList">
                <div :class="{'user-info':true,active:isActive==index}"
                 @click="checkFn(index,item)" v-if="item.companyChat=='1'">
                    <el-row>
                        <el-col :span="7" style="text-align:center;">
                            <el-avatar :size="60" :src="item.userLogo || circleUrl" class="userImag"></el-avatar>
                        </el-col>
                        <el-col :span="17">
                            <div class="name">
                                <h4>{{item.companyName}}</h4>
                                <span class="date" v-if="item.lastTime">{{item.lastTime | checkDate}}</span>
                            </div>
                            <!-- <p class="user-news"><span>[已读]</span>发斯蒂芬斯蒂芬是</p> -->
                            <p class="user-news">{{item.lastNews}}</p>
                        </el-col>
                    </el-row>
                </div>

                <div :class="{'user-info':true,active:isActive==index}"
                 @click="checkFn(index,item)" v-else>
                    <el-row>
                        <el-col :span="7" style="text-align:center;">
                            <el-avatar :size="60" :src="item.userLogo || circleUrl" class="userImag"></el-avatar>
                        </el-col>
                        <el-col :span="17">
                            <div class="name">
                                <h4>{{item.userName}}</h4>
                                <span class="date" v-if="item.lastTime">{{item.lastTime | checkDate}}</span>
                            </div>
                            <!-- <p class="user-news"><span>[已读]</span>发斯蒂芬斯蒂芬是</p> -->
                            <p class="user-news">{{item.lastNews}}</p>
                        </el-col>
                    </el-row>
                </div>

            </template>

            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return {
            userInfo:'',    // 管理员信息
            // informationList:'',     // 消息列表信息


            circleUrl:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            isRead:false,
            isActive:0,
        }
    },
    // switch:{
    //     '$store.state.message':function(newVal,oldVal){
    //         this.informationList = newVal
    //     }
    // },
    methods:{

        // index    companyChat     id
        checkFn(active,item){
            let that = this
            // console.log(this.userInfo)
            let sendId = item.sendUserId==this.userInfo.id?item.receiveUserId:item.sendUserId


            this.axiosGet(`/conversation/getUserResumeBaseInfoVo?userId=${sendId}`).then((res)=>{
                if(res.code==200){
                    res.data.chatInfo = {
                        sendId,
                        conversationId:item.id,
                        companyId:item.companyId,
                        postId:item.postId
                    }

                    // res['sendId']= sendId     // 接收人id
                    // res['conversationId'] = item.id    // 当前会话id
                    // console.log('new数据')
                    // console.log(res)
                    this.$emit('getUserInofFn',res)
                }
            })

            this.isActive = active;
        }
    },
    filters:{
        checkDate(date){
            // alert(typeof date)
            // console.log(date)
            let newArr = date.split(':')
            date = newArr[1]+":"+newArr[2]
            // console.log(date)
            return date
        }
    },
    computed:{
        informationList(){
            return this.$store.state.message.conversationVos
        }
    },
    mounted(){
    // 获得home传进来的用户列表
        this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        if(this.informationList && this.informationList.length>0){
            this.checkFn('0',this.informationList[0])

        }
    }
}
</script>
<style lang="less" scoped>
    .user-list-item{

        .user-info{
            cursor:pointer;
            padding:10px 0 10px 15px;
            .user-news{
                // background-color:Red;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                font-size: 16px;
                font-weight: 400;
                color: #666666;
                line-height: 30px;
                >span{
                    color:#6AD03D
                }
            }
        }
        .user-info.active{
            background: #E6ECF8;
            box-shadow: 0px 0px 13px 3px rgba(132, 169, 244, 0.11);
        }


    }
    .user-list-box{
        border-right:solid 2px #e6ecf8;
        height:100%;
        .name{
            h4{
                width:80%;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                text-align:left;
                font-size: 18px;
                font-weight: 400;
                color: #333333;
                line-height: 30px;
                display:inline-block;
            }
            .date{
                font-size: 14px;
                font-weight: 400;
                color: #868EA7;
                float:right;
                line-height: 30px;
                margin-right:5px;
            }
        }
    }
</style>
